/*============================================================================
  CRO product page
  - Business-day delivery window in .cro-delivery blocks
  - Sticky add to cart bar once the main button scrolls out of view
==============================================================================*/
;(function () {
  if (window.croPdpLoaded) return
  window.croPdpLoaded = true

  function addBusinessDays(days) {
    const date = new Date()
    let added = 0
    while (added < days) {
      date.setDate(date.getDate() + 1)
      if (date.getDay() !== 0 && date.getDay() !== 6) added++
    }
    return date
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })
  }

  function renderDeliveryEstimates() {
    document.querySelectorAll('.cro-delivery[data-delivery-estimate]').forEach((el) => {
      const min = parseInt(el.dataset.minDays, 10) || 0
      const max = Math.max(parseInt(el.dataset.maxDays, 10) || 0, min)
      const target = el.querySelector('[data-delivery-dates]')
      if (target) {
        target.textContent = `${formatDate(addBusinessDays(min))} to ${formatDate(addBusinessDays(max))}`
      }
    })
  }

  function initStickyAtc() {
    const bar = document.querySelector('[data-cro-sticky-atc]')
    const mainButton = document.querySelector('.page-content--product .add-to-cart')
    if (!bar || !mainButton || !('IntersectionObserver' in window)) return

    const stickyButton = bar.querySelector('[data-cro-sticky-atc-button]')

    const setVisible = (visible) => {
      bar.classList.toggle('is-visible', visible)
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true')
      stickyButton.tabIndex = visible ? 0 : -1
      document.body.classList.toggle('cro-sticky-atc-visible', visible)
    }

    // Only show once the main button has scrolled above the viewport
    new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0)
    }).observe(mainButton)

    stickyButton.addEventListener('click', () => {
      if (mainButton.disabled) return
      mainButton.click()
    })
  }

  function init() {
    renderDeliveryEstimates()
    initStickyAtc()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }

  document.addEventListener('shopify:section:load', init)
})()
